import React, { useEffect, useState } from "react";
import TableComponent from "../../Components/Comman/TableComponent";
import { MdOutlineRemoveRedEye } from "react-icons/md";
import { useLocation, useNavigate } from "react-router-dom";
import Pagination from "../../Components/Comman/Pagination";
import { ProjectService } from "../../services/ProjectService";
import { toast } from "react-toastify";
import { useSearch } from "../../context/SearchContext";
import { priorityOptions, statusOptions } from "../../Data/filterdata";
import FilterSelect from "../../Components/Comman/FilterSelect";
import { usePagination } from "../../hooks/usePagination";

/* ✅ NEW */
import MobileEmpProject from "./MobileEmpProject";

const Projects = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const isStatus = location?.state?.status || "";
  const isPriority = location?.state?.priority || "";

  const { debounceSearchTerm } = useSearch();
  const [projectList, setProjectList] = useState([]);

  const { currentPage, totalPages, goToPage, setTotalPages } = usePagination();

  const [statusFilter, setStatusFilter] = useState(isStatus);
  const [priorityFilter, setPriorityFilter] = useState(isPriority);

  const fetchProjects = async () => {
    try {
      const data = await ProjectService.getProjectList(
        currentPage,
        10,
        debounceSearchTerm,
        "",
        statusFilter,
        priorityFilter,
        "",
        ""
      );
      setProjectList(data.data);
      setTotalPages(data.pagination.totalPages);
    } catch (error) {
      toast.error(error?.message);
    }
  };

  useEffect(() => {
    fetchProjects();
  }, [statusFilter, priorityFilter, currentPage, debounceSearchTerm]);

  useEffect(() => {
    if (currentPage !== 1) {
      goToPage(1);
    }
  }, [debounceSearchTerm, statusFilter, priorityFilter]);

  useEffect(() => {
    if (isStatus || isPriority) {
      setStatusFilter(isStatus);
      setPriorityFilter(isPriority);
    }
  }, [isStatus, isPriority]);

  const handleStatusChange = async (projectId, e) => {
    const status = e.target.value;
    try {
      const response = await ProjectService.changeProjectStatus(
        projectId,
        status
      );
      if (response) {
        toast.success("Project status updated successfully");
        setProjectList((prev) =>
          prev.map((project) =>
            project.id === projectId ? { ...project, status } : project
          )
        );
      }
    } catch (error) {
      toast.error(error.message || "Failed to update status");
    }
  };

  /* ===================== DESKTOP TABLE ===================== */

  const projectColumn = [
    {
      label: "Project Id",
      field: "id",
      headerClassName:
        "text-left pl-2 border-l border-t border-b border-[#d3cccc]",
      className:
        "text-[15px] text-left pl-2 border-l border-[#d3cccc] w-[10%]",
      render: (item) => (
        <p
          className="cursor-pointer"
          onClick={() =>
            navigate(`/emp-projects-details/${item.id}`, {
              state: { projectName: item.projectName },
            })
          }
        >
          {item.id}
        </p>
      ),
    },
    {
      label: "Project Name",
      field: "projectName",
      headerClassName:
        "text-left pl-2 border-t border-b border-[#d3cccc]",
      className: "text-[15px] text-left pl-2 w-[20%]",
      render: (item) => (
        <p
          className="cursor-pointer"
          onClick={() =>
            navigate(`/emp-projects-details/${item.id}`, {
              state: { projectName: item.projectName },
            })
          }
        >
          {item.projectName}
        </p>
      ),
    },
    {
      label: "Client Name",
      field: "clientName",
      headerClassName:
        "text-left pl-2 border-t border-b border-[#d3cccc]",
      className: "text-[15px] text-left pl-2 w-[20%]",
      render: (item) => (
        <p
          className="cursor-pointer"
          onClick={() =>
            navigate(`/emp-projects-details/${item.id}`, {
              state: { projectName: item.projectName },
            })
          }
        >
          {item.clientName}
        </p>
      ),
    },
    {
      label: "Contact",
      field: "clientMobileNumber",
      headerClassName:
        "text-left pl-2 border-t border-b border-[#d3cccc]",
      className: "text-[15px] text-left pl-2 w-[10%]",
      render: (item) => (
        <p
          className="cursor-pointer"
          onClick={() =>
            navigate(`/emp-projects-details/${item.id}`, {
              state: { projectName: item.projectName },
            })
          }
        >
          {item.clientMobileNumber}
        </p>
      ),
    },
    {
      label: "Assign Date",
      field: "assignedDate",
      headerClassName:
        "text-left pl-2 border-t border-b border-[#d3cccc]",
      className: "text-[15px] text-left pl-2 w-[10%]",
      render: (item) => (
        <p
          className="cursor-pointer"
          onClick={() =>
            navigate(`/emp-projects-details/${item.id}`, {
              state: { projectName: item.projectName },
            })
          }
        >
          {item.assignedDate}
        </p>
      ),
    },
    {
      label: 'Priority',
      field: 'priority',
      headerClassName: 'text-left pl-2 border-t border-b border-[#d3cccc]',
      className: 'text-[15px] text-left pl-2 capitalize w-[10%]',
      render: (item) => (
        <p
          className={`font-medium 
            ${item.priority === 'high' 
            ? 'text-red-600' : item.priority === 'medium' 
            ? 'text-yellow-500' : item.priority === 'on-hold' 
            ? 'text-orange-500' : item.priority === 'active' 
            ? 'text-blue-500' : 'text-green-500'}`}
          onClick={() => navigate(`/emp-projects-details/${item.id}`, { state: { projectName: item.projectName } })}
        >
          {item.priority}
        </p>
      )
    },
{
  label: "Status",
  field: "status",
  headerClassName:
    "text-left pl-2 border-t border-b border-[#d3cccc]",
  className: "text-[15px] text-left pl-2 capitalize w-[10%]",
  render: (item) => (
    <div className="w-full flex justify-center items-center">
      <select
        onChange={(e) => handleStatusChange(item.id, e)}
        value={item.status}
        className={`text-sm border mx-auto bg-transparent font-medium cursor-pointer rounded px-1 py-1 focus:outline-none
          ${
            item.status === "pending"
              ? "border-yellow-600 text-yellow-600"
              : item.status === "in-progress"
              ? "border-blue-600 text-blue-600"
              : item.status === "on-hold"
              ? "border-orange-600 text-orange-800"
              : item.status === "completed"
              ? "border-green-600 text-green-800"
              : "border-zinc-400 text-zinc-600"
          }`}
      >
        <option className="text-yellow-600" value="pending">Pending</option>
        <option className="text-blue-700" value="in-progress">Active</option>
        <option className="text-orange-700" value="on-hold">On Hold</option>
        <option className="text-green-700" value="completed">Completed</option>
      </select>
    </div>
  ),
},

    {
      label: "View",
      field: "view",
      headerClassName:
        "border-r border-t border-b border-[#d3cccc] text-center",
      className:
        "border-r border-[#d3cccc] text-center w-[5%]",
      render: (item) => (
        <div className="flex justify-center items-center">
          <MdOutlineRemoveRedEye
            size={18}
            className="cursor-pointer hover:text-blue-800"
            onClick={() =>
              navigate(`/emp-projects-details/${item.id}`, {
                state: { projectName: item.projectName },
              })
            }
          />
        </div>
      ),
    },
  ];

  return (
    <section className="p-2 md:p-4">
      {/* Filters */}
      <div className="flex flex-col sm:flex-row sm:justify-end sm:items-center gap-3 sm:gap-6 mb-4">
        <FilterSelect
          options={statusOptions}
          value={statusFilter}
          onChange={(e) => setStatusFilter(e.target.value)}
          name="statusFilter"
          placeholder="Select Status"
        />

        <FilterSelect
          options={priorityOptions}
          value={priorityFilter}
          onChange={(e) => setPriorityFilter(e.target.value)}
          name="priorityFilter"
          placeholder="Select Priority"
        />
      </div>

      <div className="p-3 md:p-4 bg-white shadow-md rounded-[4px]">

        {/* ✅ MOBILE VIEW */}
        <div className="block md:hidden">
          <MobileEmpProject
            projects={projectList}
            onView={(project) =>
              navigate(`/emp-projects-details/${project.id}`, {
                state: { projectName: project.projectName },
              })
            }
            onStatusChange={handleStatusChange}
          />
        </div>

        {/* ✅ DESKTOP VIEW */}
        <div className="hidden md:block w-full overflow-x-auto">
          <TableComponent
            columns={projectColumn}
            data={projectList}
            headerBg="bg-[#f6f6f6]"
          />
        </div>

        {projectList.length > 0 && (
          <div className="mt-4">
            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              goToPage={goToPage}
            />
          </div>
        )}
      </div>
    </section>
  );
};

export default Projects;
